import { useState, useEffect } from 'react';
import Image from 'next/image';
import Logo from 'src/Resources/Images/logo.png';
import $ from 'jquery';
import axios from 'axios';
import YouInvest from 'src/Api/YouInvest';
import Link from 'next/link';

import {
    Accounts,
    PRODUCT_TYPE_MEMO_ASSETS,
    sortOrder} from 'src/Accounts';

import {generateGuid} from 'src/Utils';
import {DrupalLink} from 'src/Utils';

const accountsStore = new Accounts;

export function Header({header, topOfPageConfig, breadcrumb}) {

	const [isGuest, setIsGuest] = useState(true);

	const [searchActive, setSearchActive] = useState(false);
	const [ajbellBasket, setAjbellBasket] = useState(0);
	const [clients, setClients] = useState([]);
	const [sortedAccounts, setSortedAccounts] = useState([]);
	const [ueCode, setUeCode] = useState(null);
	const [accounts, setAccounts] = useState([]);

	useEffect(() => {		
		getUserAccounts();
		if (typeof window !== "undefined") {
			const init = async () => {
				await require('jquery-menu-aim/jquery.menu-aim');
				await require('materialize-css/js/velocity.min');	
				await require("materialize-css/js/global");
				await require('materialize-css/js/jquery.easing.1.4');
				await require('materialize-css/js/sideNav');
				await require('materialize-css/js/collapsible');
				await require('materialize-css/js/tabs');
				if ($.fn.sideNav) {
					$('.button-collapse').sideNav({
						menuWidth: 280,
						fixed: true,
						edge: 'left',
						closeOnClick: true,
						draggable: false,
					});
				}
				if ($.fn.collapsible) {
					$('.side-menu-collapsible').collapsible();
				}
			};
			init();
		}
		
		$(window).click((e) => {
            if (!$(e.target).data('excludeclick')) {
				setSearchActive(false);
            }
        });

	}, []);

	const getUserAccounts = () => {
		axios({
            method: 'GET',
            url: `/api/account/account-summary`,
            headers: YouInvest.getTradingRequestHeaders()
		}).then((response) => {
			accountsStore.setAccounts(response.data.data.accounts);
			const accountSortedAccounts = accountsStore.getAccountsSorted();

			const clients = [];
			for (let c in accountSortedAccounts) {
				clients.push({ueCode: c, name: accountSortedAccounts[c][0].name});
			}
			
			const selectedClient = clients.length ? clients[0].ueCode : null;

			setUeCode(selectedClient);
			setClients(clients);
			setAccounts(selectedClient ? getAccountsFromUeCode(accountSortedAccounts[selectedClient]) : [],);
			setSortedAccounts(accountSortedAccounts);
			setIsGuest(false);
		}).catch((response) => {
			
		})
	}

	const getAccountsFromUeCode = (sortedAccountsArr) => {
        const accountsToReturn = [];

        for (var c in sortOrder) {
            let productType = sortOrder[c];
            for (let a in sortedAccountsArr) {
                if (sortedAccountsArr[a].productType === productType) {
                    if (productType === PRODUCT_TYPE_MEMO_ASSETS) {
                        if (sortedAccountsArr[a].totalValuation > 0) {
                            accountsToReturn.push(sortedAccountsArr[a]);
                        }
                    } else {
                        accountsToReturn.push(sortedAccountsArr[a]);
                    }
                }
            }
        }
        return accountsToReturn;
	}
	
	useEffect(() => {
		if ($.fn.menuAim) {
			initDropdownMenu();
		}		
	});

	const initDropdownMenu = () => {
		const $menu = $(".dropdown-menu");
        $menu.menuAim({
            activate: function(row) {
				const $jqueryRow = $(row),
                submenuId = $jqueryRow.data("submenuId"),
                $submenu = $("#" + submenuId);

				// Show the submenu
				$submenu.css({display: "block"});

				// Keep the currently activated row's highlighted look
				$jqueryRow.find("a").addClass("maintainHover");
			},
            deactivate: function(row) {
				var $row = $(row),
                submenuId = $row.data("submenuId"),
                $submenu = $("#" + submenuId);

				// Hide the submenu and remove the row's highlighted look
				$submenu.css("display", "none");
				$row.find("a").removeClass("maintainHover");
			},
            exitMenu: function(){return true;},
            submenuDirection: 'left',
            tolerance: 100
        });
	}

	const toggleSearch = (e) => {
		e.preventDefault();
		setSearchActive(!searchActive);
	}
	
	const submitSearch = (e) => {
        window.location = '/search/all/' + encodeURI($('#edit-search-block-form--2').val());
		e.preventDefault();
		setSearchActive(!searchActive);
	}
	
	const isIe11 = () => {
		return !!window.MSInputMethodContext && !!document.documentMode;
	}

	const renderSideNav = () => {
		return <>
			<a href="#" className="button-collapse show-on-large padding-top-20-sm padding-bottom-20-sm padding-right-20-sm padding-left-20-sm block" 
				data-activates="slide-out"><span className="tb tb--sm"><span></span></span></a>

			<ul id="slide-out" className="side-nav">
				<li>
					<div className="userView margin-bottom-0 padding-top-20 z-depth-1">
						<div className="background red-500-bg redalt-500-gradient-horizontal-right">
						</div>
						<div>
							{/* <p className="white-text margin-bottom-0 padding-bottom-20 font-weight-normal line-height-medium">
                                <span className="h6 block margin-bottom-10">AJ Bell is an easy to use, award-winning platform</span>
                                <button className="c-btn waves-effect waves-light button-outline button button--outline-red c-btn-small button font-weight-bold">Open an account</button>
                            </p> */}
						</div>
					</div>
				</li>

				<li className="user-buttons"></li>

				<ul className="side-menu-collapsible" data-collapsible="accordion">
					{header.map((dropdownMenu, index) => {
						return (<li className="no-padding" key={`${index}_li`}>
							<i className="fas fa-chevron-down float-right collapsible-header" aria-hidden="true"></i>

							<a href={dropdownMenu.link.link_path} title="" className="dropdown-col3  waves-effect red-500-text">{dropdownMenu.link.link_title}</a>

							<div className="collapsible-body" key={`${index}_body`}>
								<ul>
								{dropdownMenu.below.map((sub, index) => {
									let rows = [];
									rows.push(<li key={`${index}_main`}>{renderLink(sub.link.link_path, sub.link.link_title, "subheader margin-left-neg-10")}</li>);

									{sub.below.map((link, index) => {
										rows.push(<li key={`${index}_below_sub`}>{renderLink(link.link.link_path, link.link.link_title, "waves-effect darkblue-500-text")}</li>);
									})}

									return rows;
								})}
								</ul>
							</div>
							<div className="divider margin-top-0"></div>
						</li> );
					})}
				</ul>
				<li><a className="subheader nolink">Help &amp; support</a></li>

				{
                    topOfPageConfig ? topOfPageConfig.map((item, index) => {
                        try { 
                            return <li key={index}>
                                <a className={`waves-effect font-weight-400 darkblue-500-text`} href={item.link.link_path}>
                                    {item.link.link_title}
                                </a>
                            </li>
                        } catch (e) {}
                    }) : null
                }
			</ul>
		</>
	}

	const renderLink = (url, title, classNames) => {
        return <a title={title} className={classNames} href={url}>{title}</a>;
    }

	const getAccountPortfolioLink = (account, index) => {
		const action = (account.productType === PRODUCT_TYPE_MEMO_ASSETS) ? 'mywealth' : `portfolio?accountNo=${account.number}`;
		return <a key={index} href={`/platform/${action}`} className={`c-btn c-btn-small waves-effect waves-light button-outline button margin-right-10 margin-bottom-10 inline-block ${accountsStore.getButtonOutlineColorByProduct(account.productType)}`}>
			{account.productName} - £{account.totalValuationFormatted}
		</a>
	}
					
	const clientChangeDropdownEvent = (e) => {
		const ueCode = e.target.value;
		
		setUeCode(ueCode);
		setAccounts(getAccountsFromUeCode(sortedAccounts[ueCode]));

		setTimeout(() => { // quick workaround as functional components do not have a state callback
			jQuery('#tab-overview-menu-item').show();
		}, 100);
		
	}
	
	const renderAccountMenu = () => {

        return (
            <div className="account-grid hide show">
                <div className="ajb-grid-row">
                    <div className="ajb-col-11-shift padding-10 clearfix">
                      <div className="ajb-col-collapse clearfix padding-bottom-10">
                        <div className="ajb-col-3 ajb-col-8-breakpoint">
                            <div className="form-item-group ajb-grid-row text-align-left">
                                {(clients.length > 1 && !isIe11()) ? (<select onChange={clientChangeDropdownEvent} value={ueCode} className="trading-account-menu-wrapper browser-default">
                                    {clients.map((client, clientIndex) => {
                                        return <option value={client.ueCode} key={clientIndex}>{client.name}</option>
                                    })}
                                    </select>) : (<p className="text-align-right padding-top-10 black-text font-weight-bold">
                                        {clients[0].name} :
                                	</p>)}
                            </div>
                        </div>
                        <div className="ajb-col-9 ajb-col-8-breakpoint">
                          <p className="margin-bottom-0 text-align-left margin-top-5">
                            {accounts.map((account, index) => {
                                return getAccountPortfolioLink(account, index);                             
                            })}
                          </p>
                        </div>
                      </div>
                      <hr className="ajb-grid-row" />
                    </div>
                </div>
            </div>
        );
    }

	const renderBox = dropdown => {
		if (dropdown && dropdown.link && dropdown.link.localized_options && dropdown.link.localized_options.attributes.title) {
            return <div className="megamenu-promo-container ajb-col-3 padding-20 grey-0-bg">
				<h4 className="margin-bottom-10">
					<a className="block text-underline-none maintainHover" href={dropdown.link.link_path}>{dropdown.link.link_title}</a>
				</h4>
				<p className="font-weight-normal">{dropdown.link.localized_options.attributes.title}</p>
				<div className="megamenu-promo"></div>
			</div>;
        } else {
            return null;
        }
	}

	const renderNav = () => {
		return <>						
			<div className="ajb-grid-row flex">
				<ul className="flex header__menu-items flex-justify-content-start-sm float-left">
			
				<li 
					className="inline-block flex-item flex-item-center order-2-sm margin-right-40 margin-right-10-sm" style={{height: '100%'}}>
					
					<a 
						href={`/`} 
						className="title margin-right-40 margin-right-10-sm logo" >
							<Image 
								fill
								style={{ objectFit: 'contain' }}
								src={Logo} 
								alt="AJ Bell" 
								className="image logo max-width-120"
							/>
						</a>				
					</li>    

					{/* Sidebar menu reveal button */}
					<li className="inline-block flex-item flex-item-center order-1-sm margin-right-20 margin-right-0-sm font-weight-bold hide show-sm">
                    	{renderSideNav()}
                  	</li>
				</ul>

				<ul role="menu" className="dropdown-menu flex header__menu-items flex-justify-content-start-sm float-right-sm padding-right-10-sm" style={{justifyContent: "start", flexGrow: "1"}}>

					{header.map(dropdownMenu => {
						return <li key={generateGuid()} className="inline-block flex-item flex-item-center font-weight-bold hide-sm padding-right-10 padding-left-10 megamenu-parent" data-submenu-id={dropdownMenu.link.localized_options.attributes.id + '-menu-item'}>
							<a title={dropdownMenu.link.localized_options.attributes.title} href={dropdownMenu.link.link_path} className="red-hover-link">{dropdownMenu.link.link_title}</a>

							<div className="megamenu-child popover" id={dropdownMenu.link.localized_options.attributes.id + '-menu-item'}>

								{(dropdownMenu.link.localized_options.attributes.id === 'tab-overview' && !isGuest) ? renderAccountMenu() : null}

								<div className="ajb-grid-row">
									<div className="ajb-col-10-shift padding-top-20 padding-bottom-20 clearfix">
										<div className="ajb-col-collapse megamenu-anmation">

											{renderBox(dropdownMenu)}

											{dropdownMenu.below.map(sub => {
												return <div className="ajb-col-3" key={generateGuid()}>
													<h6>
														{renderLink(sub.link.link_path, sub.link.link_title, "")}
													</h6>
													<ol>
														{sub.below.map(link => {
															return <li key={generateGuid()}>
																{renderLink(link.link.link_path, link.link.link_title, "block font-weight-normal link-arrow link-arrow-red text-underline-none")}
															</li>
														})}
													</ol>
												</div>;
											})}

										</div>
									</div>
								</div>

							</div>
						</li>;
					})}

					

					{/*(this.state.ajbellBasket > 0) ? (
					<ul id="top-account-action-btns" className="inline-block flex-item flex-item-center font-weight-bold hide show-sm margin-right-10-sm order-1-sm admin-menu-item basket-total-processed">
						<li className="checkout">
							<a href="/checkout" className="c-btn button-default waves-effect waves-light button button--green c-btn-small button font-weight-bold"><i className="fa fa-shopping-basket padding-0" aria-hidden="true"></i> <span className="h7 white-text basket-total-items">{this.state.ajbellBasket}</span> <span className="hide-sm-480">Basket</span></a>
						</li>
					</ul>
					) : null*/}

				</ul>

					{/* Second nav: Desktop | Login btns | Search | Basket */}
					<ul role="menu" className="dropdown-menu flex header__menu-items flex-justify-content-start-sm float-right-sm padding-right-10-sm" style={{justifyContent: "end", float: "revert"}}>
						
						<li className="inline-block flex-item flex-item-center font-weight-bold margin-right-10 margin-right-0-sm order-1-sm admin-menu-item block">
							{(!searchActive) ?  <span>
								{isGuest ?
									<DrupalLink className="hide-sm" action={`/securelogin`}>
										<button className="c-btn button-default waves-effect waves-red button button--darkblue white-bg darkblue-900-text c-btn-small button font-weight-bold login font-weight-bold margin-right-5"><i className="fa fa-lock hide-sm" aria-hidden="true"></i> Log in</button>
									</DrupalLink> :
									<DrupalLink className="hide-sm admin-menu-item" action={`/user/logout`}>
										<button className="c-btn button-default waves-effect waves-red button button--darkblue white-bg darkblue-900-text c-btn-small button font-weight-bold logout font-weight-bold margin-right-5"><i className="fa fa-unlock-alt hide-sm" aria-hidden="true"></i> Log out</button>
									</DrupalLink>
								}
							</span> : null}
						</li>

						<li className="inline-block flex-item flex-item-center font-weight-bold order-1-sm admin-menu-item">
							{(!searchActive && ajbellBasket > 0) ? (
								<ul id="top-account-action-btns" className="inline-block flex-item flex-item-center order-0-sm margin-right-0 margin-right-20-sm font-weight-bold hide-sm admin-menu-item basket-total-processed">
									<li className="checkout"><DrupalLink action={`/checkout`} className="c-btn button-default waves-effect waves-light button button--green c-btn-small button font-weight-bold"><i className="fa fa-shopping-basket padding-0" aria-hidden="true"></i> <span className="h7 white-text basket-total-items">{ajbellBasket}</span> <span className="hide-sm-480">Basket</span></DrupalLink></li>
								</ul>
							) : null}
						</li>

						<li className="inline-block flex-item flex-item-center font-weight-bold order-1-sm position-relative">
							<span className="text-align-left margin-right-10 padding-left-0-sm padding-right-10-sm padding-bottom-10-sm inline-block admin-serach-wrapper sb-search sb-search-alt text-align-right-sm line-height-none">

							<div className={((searchActive) ? 'active' : '') + ' input-field inline search-input margin-top-0 white-text'} data-excludeclick="true">
								<input 
									defaultValue="" 
									placeholder="Search..." 
									title="Search" 
									data-excludeclick="true" 
									type="text" 
									id="edit-search-block-form--2" 
									onKeyUp={searchKeyUp} 
									className="autocomplete"/>
							</div>

							{(!searchActive) ? (<a href="#" className="margin-left-10 sb-icon-search white-text" data-excludeclick="true" onClick={toggleSearch}>
							<i data-excludeclick="true" className="fa-search fa search-toggle padding-left-0-sm" aria-hidden="true"></i>
							</a>) : (<a href="#" className="margin-left-10 sb-icon-search white-text" data-excludeclick="true" onClick={submitSearch}>
							<i className="fa-search fa search-toggle padding-left-0-sm" data-excludeclick="true" aria-hidden="true"></i>
							</a>)}

							</span>
						</li>

						<li id="megamenu-parent" className="inline-block flex-item flex-item-center font-weight-bold hide show-sm order-2-sm">
							{isGuest ?
								<DrupalLink action={`/securelogin`}>
									<button className="c-btn button-default waves-effect waves-light button button--darkblue c-btn-small button login font-weight-bold"><i className="fa fa-lock hide-sm" aria-hidden="true"></i> Log in</button>
								</DrupalLink> :
								<DrupalLink action={`/user/logout`}>
									<button className="c-btn button-default waves-effect waves-light button button--darkblue c-btn-small button logout font-weight-bold"><i className="fa fa-unlock-alt padding-0 hide-sm" aria-hidden="true"></i> <span className="h7 white-text">Log out</span></button>
								</DrupalLink>
							}
						</li>

					</ul>



			</div>
		</>
	}

	const searchKeyUp = (e) => {
        e.stopPropagation();
        if (e.which === 13) {
            window.location = '/search/all/' + encodeURI(e.target.value)
        }
	}

	const openAccountActions = (
		<a href="#" className="modal-close waves-effect waves-green btn-flat">Close</a>
	);

	return (
		<div>
			
			<div className="hide print-only">
				<Image 
					width={256}
					height={101}
					src={Logo} 
					alt="AJ Bell"
				/>
			</div>

              {/* Admin menu bar */}
              <div className="admin-menu will-change ajb-grid-row red-500-bg padding-right-0 padding-left-20 padding-left-0-sm" style={{zIndex: '100'}}>

                {/* Breadcrumb */}
                <div className="float-left padding-10 admin-menu--breadcrumb breadcrumb-trigger hide-sm">
                  <nav className="nav-wrapper-breadcrumb nav-wrapper-breadcrumb-alt border-none">
                    <div className="nav-wrapper">
                        <a className="breadcrumb-alt" href="/" title="Home"><i className="fa fa-map-marker margin-right-5" aria-hidden="true"></i>Home</a>
                        <span className="breadcrumb-alt">Market research</span>
                        <span className="breadcrumb-alt font-weight-bold truncate">{breadcrumb}</span>
                    </div>
                  </nav>
                </div>

                <div className="float-right text-align-right admin-menu--links float-none-sm ajb-col-8-breakpoint">

                    <div className="h7 margin-0 padding-right-10">
                        {(!searchActive) ? 
						<span>
							{
                                topOfPageConfig ? topOfPageConfig.map((item, index) => {
                                    try { 
                                        let extraCssClass = item.link.localized_options.item_attributes.class === 'external' ? 'external' : '';
                                        let target = (!Array.isArray(item.link.localized_options.attributes) && item.link.localized_options.attributes.target === '_blank') ? '_blank' : '';
                                        return <a target={target} key={index} className={`margin-right-0 white-text padding-top-10 padding-right-10 padding-bottom-10 padding-left-0 inline-block ${extraCssClass}`} href={item.link.link_path}>
                                            {item.link.link_title}
                                        </a>
                                    } catch (e) {}
                                }) : null
                            }
						</span>
						: null}

                    </div>
                </div>
              </div>

            {/* Header mega menu bar */}
            <header role="banner" className="header ajb-grid-row padding-left-20 padding-right-20 padding-0-sm z-depth-0">
                {renderNav()}
            </header>

            </div>
        )
    }
